// Selected homepage coverage from the operator-supplied locations.
// Europe is intentionally limited to six points to keep the globe legible.
// Coordinates represent city centers; Australia and India use country-level positions.
// The supplied "Kansas, US-MO" is positioned at Kansas City, Missouri.
export const homeGlobeCoverage = [
  {
    id: 'secaucus',
    zh: '锡考克斯 · 美国新泽西州',
    en: 'Secaucus, US-NJ',
    longitude: -74.06,
    latitude: 40.79,
  },
  {
    id: 'ashburn',
    zh: '阿什本 · 美国弗吉尼亚州',
    en: 'Ashburn, US-VA',
    longitude: -77.49,
    latitude: 39.04,
  },
  {
    id: 'los-angeles',
    zh: '洛杉矶 · 美国加利福尼亚州',
    en: 'Los Angeles, US-CA',
    longitude: -118.24,
    latitude: 34.05,
  },
  {
    id: 'kansas',
    zh: '堪萨斯城 · 美国密苏里州',
    en: 'Kansas, US-MO',
    longitude: -94.58,
    latitude: 39.1,
  },
  {
    id: 'miami',
    zh: '迈阿密 · 美国佛罗里达州',
    en: 'Miami, US-FL',
    longitude: -80.19,
    latitude: 25.76,
  },
  {
    id: 'seattle',
    zh: '西雅图 · 美国华盛顿州',
    en: 'Seattle, US-WA',
    longitude: -122.33,
    latitude: 47.61,
  },
  {
    id: 'san-jose',
    zh: '圣何塞 · 美国加利福尼亚州',
    en: 'San Jose, US-CA',
    longitude: -121.89,
    latitude: 37.34,
  },
  {
    id: 'montreal',
    zh: '蒙特利尔',
    en: 'Montréal',
    longitude: -73.57,
    latitude: 45.5,
  },
  {
    id: 'sao-paulo',
    zh: '圣保罗',
    en: 'São Paulo',
    longitude: -46.63,
    latitude: -23.55,
  },
  {
    id: 'berlin',
    zh: '柏林',
    en: 'Berlin',
    longitude: 13.4,
    latitude: 52.52,
  },
  {
    id: 'milan',
    zh: '米兰',
    en: 'Milan',
    longitude: 9.19,
    latitude: 45.46,
  },
  {
    id: 'amsterdam',
    zh: '阿姆斯特丹',
    en: 'Amsterdam',
    longitude: 4.9,
    latitude: 52.37,
  },
  {
    id: 'madrid',
    zh: '马德里',
    en: 'Madrid',
    longitude: -3.7,
    latitude: 40.42,
  },
  {
    id: 'stockholm',
    zh: '斯德哥尔摩',
    en: 'Stockholm',
    longitude: 18.07,
    latitude: 59.33,
  },
  {
    id: 'london',
    zh: '伦敦',
    en: 'London',
    longitude: -0.13,
    latitude: 51.51,
  },
  {
    id: 'hong-kong',
    zh: '香港',
    en: 'Hong Kong',
    longitude: 114.17,
    latitude: 22.32,
  },
  {
    id: 'tokyo',
    zh: '东京',
    en: 'Tokyo',
    longitude: 139.69,
    latitude: 35.68,
  },
  {
    id: 'singapore',
    zh: '新加坡',
    en: 'Singapore',
    longitude: 103.82,
    latitude: 1.35,
  },
  {
    id: 'taipei',
    zh: '台北',
    en: 'Taipei',
    longitude: 121.57,
    latitude: 25.03,
  },
  {
    id: 'lagos',
    zh: '拉各斯',
    en: 'Lagos',
    longitude: 3.38,
    latitude: 6.52,
  },
  {
    id: 'johannesburg',
    zh: '约翰内斯堡',
    en: 'Johannesburg',
    longitude: 28.05,
    latitude: -26.2,
  },
  {
    id: 'australia',
    zh: '澳大利亚',
    en: 'Australia',
    longitude: 134,
    latitude: -25,
  },
  {
    id: 'india',
    zh: '印度',
    en: 'India',
    longitude: 79,
    latitude: 22,
  },
  {
    id: 'shanghai',
    zh: '上海',
    en: 'Shanghai',
    longitude: 121.47,
    latitude: 31.23,
  },
  {
    id: 'hangzhou',
    zh: '杭州',
    en: 'Hangzhou',
    longitude: 120.16,
    latitude: 30.27,
  },
  {
    id: 'beijing',
    zh: '北京',
    en: 'Beijing',
    longitude: 116.41,
    latitude: 39.9,
  },
  {
    id: 'guangzhou',
    zh: '广州',
    en: 'Guangzhou',
    longitude: 113.26,
    latitude: 23.13,
  },
] as const
